module.exports = __webpack_public_path__ + "img/racecourse-fairview-poly-1100.b332bd62.svg";